module.exports = __webpack_public_path__ + "static/inspospotr-casebg@2x-min-f647a2a42fe8103ea3e93ca01cc30277.jpg";